// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2f8v-","footer":"Form_footer__Iwt3W"};